// eslint-disable-next-line
import { getRouters } from '@/api/menu'
import { getIndexRouterMap } from '@/config/router.config'
import allIcon from '@/core/icons'
import { validURL } from '@/utils/validate'
import { UserLayout, BlankLayout, PageView } from '@/layouts'
import auth from '@/plugins/auth'
import i18n from '@/locales'
// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: () => import('@/layouts/BasicLayout'),
  BlankLayout: BlankLayout,
  RouteView: () => import('@/layouts/RouteView'),
  PageView: PageView,
  UserLayout: UserLayout, // 登陆注册页面的通用布局

  // 你需要动态引入的页面组件
  'Index': () => import('@/views/index'),
  // account
  'AccountCenter': () => import('@/views/account/center'),
  'AccountSettings': () => import('@/views/account/settings'),
  // job log
  'JobLog': () => import('@/views/monitor/job/log'),
  // 授权用户
  'AuthUser': () => import('@/views/system/role/authUser'),
  // 公告新增修改
  'NoticeForm': () => import('@/views/system/notice/CreateForm'),
  // 商品列表新增修改
  'goodsForm': () => import('@/views/mall/goods/CreateForm'),
  //
  'zrIndex': () => import('@/views/sms/channel/zrdata'),
  // 修改生成配置
  'GenEdit': () => import('@/views/tool/gen/modules/GenEdit')
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true
}

// 根级菜单
const getRootMenu = () => ({
  key: '',
  name: 'index',
  path: '',
  component: 'BasicLayout',
  redirect: '/index',
  meta: {
    title: i18n.t('route.home')
  },
  children: []
})

// 菜单名称国际化映射函数
const getMenuLabel = (title) => {
  if (!title || typeof title !== 'string') return title
  
  // 如果 title 是国际化键值（以 route. 开头），直接使用 i18n.t
  if (title.startsWith('route.')) {
    return i18n.t(title)
  }
  
  // 菜单名称国际化映射表
  const menuLabelMap = {
    '短剧管理': 'menu.videoManagement',
    '短剧列表': 'menu.videoList',
    '弹幕管理': 'menu.barrageManagement',
    '宣传片管理': 'menu.publicizeManagement',
    '敏感词管理': 'menu.sensitiveWordManagement',
    '短剧分类管理': 'menu.videoCategoryManagement',
    '用户购买剧集列表': 'menu.userBuyVideoList',
    '用户管理': 'menu.userManagement',
    '用户信息': 'menu.userInfo',
    '用户提现': 'menu.userWithdraw',
    '用户反馈': 'menu.userFeedback',
    '用户注销管理': 'menu.userCancelManagement',
    '用户报表': 'menu.userReport',
    '用户权益': 'menu.userRights',
    '兑换码': 'menu.exchangeCode',
    '拉人奖励配置': 'menu.referralRewardConfig',
    '会员购买列表': 'menu.vipPurchaseList',
    '签到配置': 'menu.signConfig',
    '任务奖励管理': 'menu.taskRewardManagement',
    '充值管理': 'menu.rechargeManagement',
    '充值菜单管理': 'menu.rechargeMenuManagement',
    '会员菜单管理': 'menu.vipMenuManagement',
    '资源位配置': 'menu.resourcePositionConfig',
    '网址管理': 'menu.urlManagement',
    '帮助中心': 'menu.helpCenter',
    '引导页': 'menu.guidePage',
    '分销配置': 'menu.distributionConfig',
    '轮播图管理': 'menu.carouselManagement',
    '搜索词管理': 'menu.searchWordManagement',
    '头像管理': 'menu.avatarManagement',
    'Tabbar管理': 'menu.tabbarManagement',
    '手机区号管理': 'menu.mobileCodeManagement',
    '财务报表': 'menu.financialReport',
    '短剧报表': 'menu.videoReport',
    '金币充值订单列表': 'menu.coinRechargeOrderList',
    '版本更新': 'menu.versionUpdate',
    '版本管理': 'menu.versionManagement',
    '系统管理': 'menu.systemManagement',
    '用户查询': 'menu.userQuery',
    '用户新增': 'menu.userAdd',
    '用户修改': 'menu.userEdit',
    '用户删除': 'menu.userDelete',
    '用户导出': 'menu.userExport',
    '用户导入': 'menu.userImport',
    '重置密码': 'menu.resetPassword',
    '角色管理': 'menu.roleManagement',
    '角色查询': 'menu.roleQuery',
    '角色新增': 'menu.roleAdd',
    '角色修改': 'menu.roleEdit',
    '角色删除': 'menu.roleDelete',
    '脱敏权限': 'menu.maskPermission',
    '菜单管理': 'menu.menuManagement',
    '菜单查询': 'menu.menuQuery',
    '菜单新增': 'menu.menuAdd',
    '菜单修改': 'menu.menuEdit',
    '菜单删除': 'menu.menuDelete',
    '参数设置': 'menu.paramSettings',
    '参数查询': 'menu.paramQuery',
    '参数新增': 'menu.paramAdd',
    '参数修改': 'menu.paramEdit',
    '参数删除': 'menu.paramDelete',
    '参数导出': 'menu.paramExport',
    '通知公告': 'menu.noticeAnnouncement',
    '公告查询': 'menu.noticeQuery',
    '公告新增': 'menu.noticeAdd',
    '公告修改': 'menu.noticeEdit',
    '公告删除': 'menu.noticeDelete',
    '日志管理': 'menu.logManagement',
    '操作日志': 'menu.operationLog',
    '操作查询': 'menu.operationQuery',
    '操作删除': 'menu.operationDelete',
    '日志导出': 'menu.logExport',
    '登录日志': 'menu.loginLog',
    '登录查询': 'menu.loginQuery',
    '登录删除': 'menu.loginDelete',
    '账户解锁': 'menu.accountUnlock',
    '系统工具': 'menu.systemTools',
    '表单构建': 'menu.formBuilder',
    '代码生成': 'menu.codeGeneration',
    '生成查询': 'menu.generateQuery',
    '生成修改': 'menu.generateEdit',
    '生成删除': 'menu.generateDelete',
    '导入代码': 'menu.importCode',
    '预览代码': 'menu.previewCode',
    '生成代码': 'menu.generateCode',
    '系统接口': 'menu.systemInterface',
    '数据库文档': 'menu.databaseDoc',
    '系统监控': 'menu.systemMonitor',
    '数据监控': 'menu.dataMonitor',
    '服务监控': 'menu.serviceMonitor',
    '缓存监控': 'menu.cacheMonitor',
    '缓存列表': 'menu.cacheList'
  }
  
  // 如果 title 在映射表中，使用映射的国际化键值进行翻译
  const i18nKey = menuLabelMap[title]
  if (i18nKey) {
    return i18n.t(i18nKey)
  }
  
  // 否则直接返回原始标题
  return title
}

// 根级路由
const getRootRouter = () => ({
  key: '',
  name: 'index',
  path: '',
  component: constantRouterComponents.BasicLayout,
  redirect: '/index',
  meta: {
    title: i18n.t('route.home')
  },
  children: []
})

/**
 * 动态生成菜单
 * @param token
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = (token) => {
  return new Promise((resolve, reject) => {
    // 向后端请求路由数据
    getRouters().then(res => {
      // 路由菜单分离，路由全部为二级，解决多级菜单缓存问题
      const routers = []
      const menuNav = []
      const routerData = res.data
      const asyncRoutes = filterDynamicRoutes(getIndexRouterMap())
      const rootMenu = getRootMenu()
      rootMenu.children = asyncRoutes.concat(routerData)
      menuNav.push(rootMenu)
      const menus = generator(menuNav, null, routers)
      menus.push(notFoundRouter)
      const rootRouter = getRootRouter()
      rootRouter.children = routers
      resolve({ menus, routers: rootRouter })
    }).catch(err => {
      reject(err)
    })
  })
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes (routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    } else {
      res.push(route)
    }
  })
  return res
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @param routers
 * @returns {*}
 */
export const generator = (routerMap, parent, routers) => {
  const names = parent ? parent.meta.names : []
  return routerMap.map(item => {
    // 适配ruoyi一级菜单
    if (item.path === '/' && item.children && item.children.length === 1) {
      item = item.children[0]
      item.children = undefined
    }

    const { title, show, hideChildren, hiddenHeaderContent, hidden, icon, noCache } = item.meta || {}
    if (item.isFrame === 0) {
      item.target = '_blank'
    }
    const name = item.name || item.key || ''
    const isRouter = item.component && item.component !== 'Layout' && item.component !== 'ParentView'
    // 使用 getMenuLabel 函数处理菜单标题的国际化
    const translatedTitle = getMenuLabel(title)
    const currentRouter = {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: item.path || `${parent && parent.path || ''}/${item.path}`,
      // 路由名称，建议唯一
      name: name,
      // 该路由对应页面的 组件(动态加载)
      component: (constantRouterComponents[item.component || item.key]) || (() => import(`@/views/${item.component}`)),
      hidden: item.hidden,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: translatedTitle,
        icon: allIcon[icon + 'Icon'] || icon,
        hiddenHeaderContent: hiddenHeaderContent,
        // 目前只能通过判断path的http链接来判断是否外链，适配若依
        target: validURL(item.path) ? '_blank' : '',
        permission: item.name,
        keepAlive: noCache === undefined ? false : !noCache,
        hidden: hidden,
        // 因菜单路由分离，通过此names确定菜单树的展开
        names: names.concat([name])
      },
      redirect: item.redirect
    }
    // 是否设置了隐藏菜单
    if (show === false) {
      currentRouter.hidden = true
    }
    // 适配若依，若依为缩写路径，而antdv-pro的pro-layout要求每个路径需为全路径
    if (!constantRouterComponents[item.component || item.key]) {
      // currentRouter.path = `${parent && parent.path !== '/' && parent.path || ''}/${item.path}`
      currentRouter.path = `${parent && parent.path !== '/' && parent.path + '/' || ''}${item.path}`
    }
    // 是否设置了隐藏子菜单
    if (hideChildren) {
      currentRouter.hideChildrenInMenu = true
    }
    // const names = parent.names
    const router = {
      path: currentRouter.path,
      // 路由名称，建议唯一
      name: currentRouter.name,
      // 该路由对应页面的 组件(动态加载)
      component: currentRouter.component,
      hidden: currentRouter.hidden,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: currentRouter.meta,
      redirect: currentRouter.redirect
    }
    if (router.component && isRouter) {
      routers.push(router)
    }
    // 是否有子菜单，并递归处理，并将父path传入
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter, routers)
    }
    return currentRouter
  })
}
